import axios from 'axios'
import config from './config'

const instance = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
    'X-API-KEY': config.API_KEY,
  },
  timeout: 90000, // 90s
})

instance.interceptors.response.use(
  (res) => {
    return res
  },
  async (err) => {
    if (err.response?.status === 503) {
      location.href = '/maintenance'
      return Promise.reject(err)
    }
  }
)

export default instance
